import React, { useEffect, useState } from 'react';
import './PaymentSuccess.css';
import { useCart } from '../CartContext';

export default function PaymentSuccess({ onMyEvents, onHome }) {
  const { clearCart } = useCart();

  // Lazy initializer: reads localStorage once at mount, stable across re-renders.
  // Must happen before useEffect so isRosterAdd is correct on the first paint.
  const [items] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ovr_pending_payment') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.removeItem('ovrRegDraft');
    localStorage.removeItem('ovr_pending_payment');
    // Clear all cart keys (guest + any user-specific) so auth-load doesn't restore old items.
    for (const k of Object.keys(localStorage)) {
      if (k.startsWith('ovr_cart_v1_')) localStorage.removeItem(k);
    }
    clearCart();
    // The Stripe webhook is the sole authority for marking rows paid.
    // Never update payment_status from the client - RLS must forbid it anyway.
  }, [clearCart]);

  const typeLabel = {
    tournament_team: 'TEAM REG',
    tournament_fa:   'FREE AGENT',
    dropin:          'DROP-IN',
    membership:      'MEMBERSHIP',
    roster_add:      'ROSTER ADD',
  };

  const isRosterAdd = items.some(item => item.type === 'roster_add');

  return (
    <div className="ps-page">
      <div className="ps-inner">
        {/* Check mark */}
        <div className="ps-check">
          <svg viewBox="0 0 52 52" fill="none">
            <circle cx="26" cy="26" r="25" stroke="#9D1515" strokeWidth="2" />
            <path d="M14 27l8 8 16-16" stroke="#9D1515" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <div className="ps-eyebrow">{isRosterAdd ? 'ROSTER UPDATED' : 'PAYMENT CONFIRMED'}</div>
        <h1 className="ps-title">{isRosterAdd ? "PLAYERS LOCKED IN." : "YOU'RE IN."}</h1>
        <p className="ps-sub">
          {isRosterAdd
            ? `New player${items[0]?.sublabel?.includes(',') ? 's are' : ' is'} on the roster. A receipt has been sent to your email.`
            : `Your registration${items.length !== 1 ? 's are' : ' is'} confirmed and your spot${items.length !== 1 ? 's are' : ' is'} locked in. A receipt has been sent to your email.`
          }
        </p>
        <p className="ps-spam-note">
          📬 Confirmation emails come from <strong>noreply@ovrleague.com</strong>. If you don't see it, check your spam folder and mark it <strong>Not Spam</strong> to receive future emails in your inbox.
        </p>

        {/* Confirmation cards */}
        {items.length > 0 && (
          <div className="ps-cards">
            {items.map((item, i) => (
              <div key={i} className="ps-card">
                <div className="ps-card__top">
                  <span className="ps-card__type">{typeLabel[item.type] || 'REGISTRATION'}</span>
                  <span className="ps-card__paid">✓ PAID</span>
                </div>
                <div className="ps-card__label">{item.label}</div>
                {item.sublabel && <div className="ps-card__sublabel">{item.sublabel}</div>}
                <div className="ps-card__conf-row">
                  <span className="ps-card__conf-label">CONFIRMATION #</span>
                  <span className="ps-card__conf-num">{item.confNum}</span>
                </div>
                <div className="ps-card__fee">{item.fee}</div>
              </div>
            ))}
          </div>
        )}

        {/* Actions */}
        <div className="ps-actions">
          <button className="ps-btn ps-btn--primary" onClick={onMyEvents}>
            VIEW MY EVENTS →
          </button>
          <button className="ps-btn ps-btn--ghost" onClick={onHome}>
            BACK TO HOME
          </button>
        </div>

        <p className="ps-footer-note">
          Receipt sent from <strong>noreply@ovrleague.com</strong>. Check spam if you don't see it. Questions?{' '}
          <a href="mailto:ovrleague@gmail.com">ovrleague@gmail.com</a>
        </p>
      </div>
    </div>
  );
}
